export default "__VITE_ASSET__CCfMpbzL__"